import { render } from "./lei-search-details.vue?vue&type=template&id=6074faee&ts=true"
import script from "./lei-search-details.vue?vue&type=script&lang=ts"
export * from "./lei-search-details.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__